// we expect that the date format in the input is yyyy-mm-dd
$(function () {
  function onStart() {
    var currentVal = this.get('value');

    if (!currentVal) {
      var today = new Date();
      if (!this.$node.data('datepicker-blank')) {
        this.set('select', [today.getFullYear(), today.getMonth(), today.getDate()]);
      }
    } else {
      // we subtract 1 from the month because JS months are zero indexed
      var dateParts = currentVal.split('-');
      this.set('select', [dateParts[0], parseInt(dateParts[1]) - 1, dateParts[2]]);
    }
  }

  $('.datepicker').pickadate({
    format: 'mmm d, yyyy',
    onStart: onStart
  });

  $('.datepicker-past').pickadate({
    format: 'mmm d, yyyy',
    max: 1,
    onStart: onStart
  });

  $('.datepicker-auctions').pickadate({ min: 1, format: 'mmm d, yyyy' });
  $('.timepicker').pickatime({ format: 'hA' });
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/datepicker.js